<script>
import axios from "axios";
import appConfig from "@/app.config";
export default {
  page: {
    title: "Login ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      username: "",
      password: "",
      error: "",
      loader: false,
      showPassword: false,
    };
  },
  methods: {
    async login() {
      this.loader = true;
      let formData = new FormData();
      formData.append("username", this.username);
      formData.append("password", this.password);
      let url = "/login";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          if(response.data.user.user_type > 2){
            this.error = 'You are not authorized to access this page';
            this.loader = false;
            return;
          }
          let userData = response.data.user;
          let token = response.data.token;
          let financialyear = response.data.financialyear;
          let license = response.data.license;
          let branches = response.data.branches;
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          localStorage.setItem("user", JSON.stringify(userData));
          localStorage.setItem("token", token);
          localStorage.setItem("financialyear", financialyear);
          localStorage.setItem("license", license);
          localStorage.setItem("branches", JSON.stringify(branches));

          // checks for a valid license
          const end_date = new Date(localStorage.getItem('license'))
          const today = new Date()
          if (end_date < today) {
            localStorage.setItem('active_license', 0)
          } else {
            localStorage.setItem('active_license', 1)
          }
          
              this.$router.push(
                this.$route.query.redirectFrom || { name: "default" }
              );
        } else {
          this.error = response.data.message;
          this.loader = false;
        }
      });
    },
    togglePasswordVisibilty() {
      this.showPassword = !this.showPassword;
    },
  },
  mounted() {
    document.body.classList.add("auth-body-bg");
  },
  computed: {
    inputType() {
      return this.showPassword ? "text" : "password";
    },
  },
};
</script>

<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row g-0">
        <!-- Left Panel - Image Section -->
        <div class="col-xl-8 d-none d-md-block position-relative">
          <div class="image-container h-100">
            <img 
              src="@/assets/images/bana.jpeg" 
              class="img-fluid h-100 w-100" 
              style="object-fit: cover;"
              alt="Banner"
            />
            <div class="image-overlay"></div>
          </div>
        </div>

        <!-- Right Panel - Login Form -->
        <div class="col-xl-4 login-panel">
          <div class="auth-full-page-content p-md-5 p-4">
            <div class="w-100">
              <div class="d-flex flex-column h-100">
                <div class="my-auto">
                  <!-- Logo and Header Section -->
                  <div class="text-center mb-4">
                    <div class="logo-container mb-3">
                      <img 
                        src="@/assets/images/logo.png"
                        height="80px" 
                        class="logo-image"
                        alt="Logo"
                      />
                    </div>
                    <h4 class="text-primary fw-bold mb-2">Welcome Back!</h4>
                    <p class="text-muted">Sign in to continue to your account</p>
                  </div>

                  <!-- Error Message -->
                  <div 
                    v-if="error" 
                    class="alert alert-danger alert-dismissible fade show d-flex align-items-center mb-4" 
                    role="alert"
                  >
                    <i class="mdi mdi-alert-circle-outline me-2"></i>
                    <div>{{ error }}</div>
                  </div>

                  <!-- Login Form -->
                  <div class="card border-0 shadow-sm">
                    <div class="card-body p-4">
                      <b-form @submit.prevent="login">
                        <!-- Username Field -->
                        <b-form-group class="mb-4" id="input-group-1">
                          <label for="input-1" class="form-label fw-medium">
                            <i class="mdi mdi-account-outline text-muted me-1"></i>
                            Username
                          </label>
                          <div class="input-group">
                            <span class="input-group-text bg-light border-end-0">
                              <i class="mdi mdi-account"></i>
                            </span>
                            <b-form-input 
                              id="input-1" 
                              v-model="username" 
                              type="text"
                              placeholder="Enter your username"
                              class="border-start-0 ps-0"
                              required
                            />
                          </div>
                        </b-form-group>

                        <!-- Password Field -->
                        <b-form-group class="mb-4" id="input-group-2">
                          <label for="input-2" class="form-label fw-medium">
                            <i class="mdi mdi-lock-outline text-muted me-1"></i>
                            Password
                          </label>
                          <div class="input-group">
                            <span class="input-group-text bg-light border-end-0">
                              <i class="mdi mdi-lock"></i>
                            </span>
                            <b-form-input 
                              id="input-2" 
                              v-model="password" 
                              required
                              :type="inputType"
                              placeholder="Enter your password"
                              class="border-start-0 border-end-0 ps-0"
                            />
                            <button 
                              class="btn btn-light border-start-0" 
                              type="button" 
                              @click="togglePasswordVisibilty"
                            >
                              <i 
                                :class="[
                                  'mdi',
                                  showPassword ? 'mdi-eye-off' : 'mdi-eye',
                                  'text-muted'
                                ]"
                              ></i>
                            </button>
                          </div>
                        </b-form-group>

                        <!-- Remember Me Checkbox -->
                        <div class="d-flex justify-content-between align-items-center mb-4">
                          <div class="form-check">
                            <input 
                              class="form-check-input" 
                              type="checkbox" 
                              id="remember-check"
                            />
                            <label class="form-check-label text-muted" for="remember-check">
                              Remember me
                            </label>
                          </div>
                          <a href="#" class="text-primary text-decoration-none small">
                            Forgot Password?
                          </a>
                        </div>

                        <!-- Login Button -->
                        <div class="d-grid">
                          <b-button 
                            type="submit" 
                            variant="primary" 
                            size="lg"
                            class="fw-medium"
                            :disabled="loader"
                          >
                            <span v-if="!loader">
                              <i class="mdi mdi-login me-1"></i>
                              Sign In
                            </span>
                            <span v-else>
                              <b-spinner small class="me-2" />
                              Signing In...
                            </span>
                          </b-button>
                        </div>
                      </b-form>
                    </div>
                  </div>
                </div>

                <!-- Footer -->
                <div class="mt-2 text-center">
                  <p class="text-muted small mb-0">
                    © {{ new Date().getFullYear() }} All rights reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// Carousel styling (keeping original)
::v-deep .carousel-caption {
  position: relative !important;
  right: 0;
  bottom: 1.25rem;
  left: 0;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #495057;
  text-align: center;
}

::v-deep .carousel-indicators li {
  background-color: rgba(85, 110, 230, 0.25);
}

// Image container styling
.image-container {
  position: relative;
  overflow: hidden;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(13, 110, 253, 0.1) 0%, rgba(13, 110, 253, 0.05) 100%);
}

// Login panel styling
.login-panel {
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 10;
}

// Logo styling
.logo-container {
  transition: transform 0.3s ease;
}

.logo-image {
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.logo-image:hover {
  transform: scale(1.05);
}

// Card styling
.card {
  border-radius: 1rem;
  transition: all 0.3s ease;
}

.card:hover {
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.1) !important;
}

// Input group styling
.input-group-text {
  border-right: none;
  background-color: #f8f9fa;
  transition: all 0.3s ease;
}

.form-control {
  transition: all 0.3s ease;
}

.form-control:focus {
  border-color: #0d6efd;
  box-shadow: none;
}

.input-group:focus-within .input-group-text {
  border-color: #0d6efd;
  background-color: #e7f1ff;
}

.input-group:focus-within .btn-light {
  border-color: #0d6efd;
  background-color: #e7f1ff;
}

// Button styling
.btn {
  border-radius: 0.5rem;
  padding: 0.75rem 1.5rem;
  transition: all 0.3s ease;
}

.btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(13, 110, 253, 0.3);
}

.btn:active:not(:disabled) {
  transform: translateY(0);
}

.btn-light {
  background-color: #f8f9fa;
  border-color: #ced4da;
}

.btn-light:hover {
  background-color: #e9ecef;
}

// Alert styling
.alert {
  border-radius: 0.75rem;
  border: none;
  animation: slideDown 0.3s ease;
}

// Checkbox styling
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

// Link styling
a {
  transition: all 0.3s ease;
}

a:hover {
  opacity: 0.8;
}

// Responsive adjustments
@media (max-width: 767.98px) {
  .logo-image {
    height: 60px !important;
  }
  
  .card-body {
    padding: 1.5rem !important;
  }

  .login-panel {
    box-shadow: none;
  }
}

// Animation for error alert
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// Password toggle button
.toggle-password {
  cursor: pointer;
}
</style>